import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SearchComponent } from './header/search/search.component';
import {MyTranslateModule} from '../modules/my-translate-module/my-translate-module';

@NgModule({
  imports: [
    RouterModule,
    SharedModule,
    MyTranslateModule
  ],
    declarations: [
        LayoutComponent,
        SidebarComponent,
        HeaderComponent,
        SearchComponent
    ],
    exports: [
        LayoutComponent,
        SidebarComponent,
        HeaderComponent,
        SearchComponent
    ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// ./src/app/layout/layout.module.ts